import { camelize } from 'humps'

export default function selectSearchHighlights(highlights, field) {
  if (!highlights) {
    return []
  }

  if (!field) {
    return highlights
  }

  return highlights.filter(
    highlight => camelize(highlight.fieldName || '') === field
  )
}



// WEBPACK FOOTER //
// ../src/selectors/selectSearchHighlights.js